import Modal from 'react-modal';


export default function PlanItemModal(props) {


  return (
    <Modal
      isOpen={props.visible}
      onRequestClose={props.onClose}
    >
      <div className="container">
        <div className="mb-4">
          <h2>{props.item.product.name}</h2>
          {!!props.item.product.description && (
            <p dangerouslySetInnerHTML={{__html: props.item.product.description}}/>
          )}
          {!!props.item?.product.width && (
            <>
              <h6>Wymiary</h6>
              <p>{props.item?.product.width}cm x {props.item?.product.height}cm x {props.item?.product.depth}cm</p>
            </>
          )}
        </div>
        <hr/>
        <div className="mb-4">
          <h5>Elementy dodatkowe</h5>
          <div className="list-group">
            {props.item.elements.length ? props.item.elements.map((el, idx) => (
              <div key={idx} className="list-group-item">
                <div className="row">
                  <div className="col-sm">
                    <span>{el.product.name} {el.place}</span>
                  </div>
                  <div className="col-sm-2">
                    <input
                      className="form-control"
                      type="number"
                      value={el.value}
                      min={1}
                      max={el.product.type.startsWith('element_obwodowy') ? 2 : 1000}
                      step={1}
                      onChange={e => {
                        const arr = [...props.item.elements];
                        arr[idx].value = e.target.value;
                        props.editCustomElements(arr);
                      }}
                    />
                  </div>
                  <div className="col-sm-auto">
                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        const arr = [...props.item.elements];
                        arr.splice(idx, 1)
                        props.editCustomElements(arr);
                      }}
                    >Usuń</button>
                  </div>
                </div>

              </div>
            )) : (
              <p>Brak dodatkowych elementów</p>
            )}

          </div>
        </div>

        <hr/>

        <div className="row justify-content-end">
          <div className="col-sm-auto">
            <button className="btn btn-outline-primary" onClick={props.onClose}>Zamknij podgląd</button>
          </div>
          <div className="col-sm-auto">
            <button className="btn btn-danger" onClick={props.onDelete}>Usuń panel</button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
